import { render } from "./Slider.htm?vue&type=template&id=526536a8"
import script from "./Slider.js?vue&type=script&lang=js"
export * from "./Slider.js?vue&type=script&lang=js"

import "./Slider.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__